import React from 'react';

import 'LIBRARY/Components/component.css';
import 'LIBRARY/Components/LibraryDetails/librarydetails.css';
import 'LIBRARY/Components/modal.css';
import { Base64 } from 'js-base64';
import ReactHtmlParser from 'react-html-parser';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import LibraryApiCall from 'LIBRARY/LibraryApiCall';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import config from 'LIBRARY/config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import bookImage from 'LIBRARY/Components/LibraryDetails/images/bookCover.png';
import Pagination from 'react-js-pagination';
import queryString from 'query-string'

class LibraryDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            instituteUrl: this.props.match.params.instituteUrl,
            instituteDetailsFetching: false,
            invalidUrl: false,
            instituteId: '',
            instituteName: '',

            // VARIABLES TO GET LIBRARY BOOK DETAILS
            bookFetching: false,
            bookDetails: {},
            filterTitle: '',
            filterAuthor: '',
            filterDepartment: '',
            filterLocation: '',
            filterResourceType: '',
            filterAccessionNumber: '',
            filterEdition: '',
            filterISBNNumber: '',
            filterAccessionSeries: '',
            filteredCategoryId:'',
            limit: 30,
            pageIndex: 1,
            total: 0,

            // VARIABLES FOR FILTER
            currentActiveFilter: 'all',
            departmentList: {},
            locationList: [],
            accessionSeriesList: {},
            categoryList:{},
            resourceTypes: ['Text Book', 'Reference Book', 'Atlas', 'Biography', 'Book with CD', 'CD-ROM', 'Floppy', 'General'],

            // VARIABLES TO VIEW LIBRARY BOOK
            viewBook: false,
            uniqueBookId: '',
            individualBookFetching: false,
            individualBookDetails: {},


            // VARIABLES FOR SUCCESS MODAL
            successModal: false, 
            successModalType:'',
            successMessage:''
        };
    }

    componentDidMount() {
        // const query = new URLSearchParams(this.props.location.search);
        let categoryId = this.props.match.params.categoryId;
        if(categoryId != undefined && categoryId != "")
        {
            categoryId = Base64.decode(categoryId);
            
            this.setState({
                currentActiveFilter:"browse",
                filteredCategoryId:categoryId
            },() => this.apiCallToGetLibraryBooksDetails())
        }

        window.onscroll = () => {
            const body = document.body;
            const html = document.documentElement;
            
            let documentHeight = Math.max(
                body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight
            );

            let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

            if (scrollTop < documentHeight - window.innerHeight) return;

            this.setState({
                pageIndex: this.state.pageIndex + 1
            }, () => {
                if(Object.keys(this.state.bookDetails).length > 0) {        
                    // METHOD CALLED TO GET LIBRARY BOOKS DETAILS
                    this.apiCallToGetLibraryBooksDetails();
                }
            });
        };

        // METHOD CALLED TO GET INSTITUTE DETAILS BY INSTITUTE URL
        this.apiCallToGetInstituteDetails();
            
        // METHOD CALLED TO GET DEPARTMENT LIST
        this.apiCallToGetDepartmentList();
            
        // METHOD CALLED TO GET ACCESSION SERIES LIST
        this.apiCallToGetAccessionSeriesList();
            
        // METHOD CALLED TO GET LOCATION LIST
        this.apiCallToGetLocationList();

        // METHOD CALLED TO GET CATEGORY LIST
        this.apiCallToGetCategoryList();
            
        // METHOD CALLED TO GET LIBRARY BOOKS DETAILS
        this.apiCallToGetLibraryBooksDetails();
    }

    // API CALL METHOD TO GET INSTITUTE DETAILS BY INSTITUTE URL
    apiCallToGetInstituteDetails = async () => {
        this.setState({
            instituteDetailsFetching: true,
        });
        let requestData = {
            "url":this.state.instituteUrl,
        };

        let jsonResponse = await LibraryApiCall.makeLibraryApiCall(
            'getInstituteDataByURL',
            requestData,
            '/api/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    instituteId: apiResult.instituteId,
                    instituteName: apiResult.InstituteName,
                    instituteDetailsFetching: false
                });
            } else {
                if(jsonResponse.APIResult.message == 'Invalid URL.') {
                    this.setState({
                        invalidUrl: true,
                        instituteDetailsFetching: false
                    });
                }else {
                    this.setState({
                        instituteDetailsFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting institute details. Please try again later.'
                    });
                }
            }
        }
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    apiCallToGetDepartmentList = async () => {
        let requestData = {
            "instituteUrl":this.state.instituteUrl,
            'searchName': ''
        };

        let jsonResponse = await LibraryApiCall.makeLibraryApiCall(
            'getInstituteStreamListForPublic',
            requestData,
            '/api/library/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetDepartmentList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.streamData;
                this.setState({
                    departmentList: apiResult,
                });
            } else {
                this.setState({
                    instituteDetailsFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting department list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET ACCESSION SERIES LIST
    apiCallToGetAccessionSeriesList = async () => {
        let requestData = {
            "instituteUrl":this.state.instituteUrl,
        };

        let jsonResponse = await LibraryApiCall.makeLibraryApiCall(
            'GetLibraryAccessionSeriesForPublic',
            requestData,
            '/api/library/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeriesList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(seriesId => {
                        apiResult[seriesId]['seriesId'] = seriesId;
                    });
                }
                this.setState({
                    accessionSeriesList: apiResult,
                });
            } else {
                this.setState({
                    instituteDetailsFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET LOCATION LIST
    apiCallToGetLocationList = async () => {
        let requestData = {
            "instituteUrl":this.state.instituteUrl,
            'pageIndex': 1,
            'limit': 5000
        };

        let jsonResponse = await LibraryApiCall.makeLibraryApiCall(
            'GetLibraryLocationListForPublic',
            requestData,
            '/api/library/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let locationList = this.state.locationList;
                locationList = {};
                if(Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map((uniqueId, parentIndex) => {
                        apiResult[uniqueId]['locationId'] = uniqueId;
                        if(Object.keys(apiResult[uniqueId].sublocation).length > 0) {
                            Object.keys(apiResult[uniqueId].sublocation).map(subLocId => {
                                apiResult[uniqueId].sublocation[subLocId]['locationId'] = subLocId;
                            });
                        }
                    })
                }

                this.setState({
                    locationList: apiResult
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting location list. Please try again later.'
                });
            }
        }
    }
    // API CALL METHOD TO GET CATEGORY LIST
    apiCallToGetCategoryList = async () => {
        let requestData = {
            "instituteUrl":this.state.instituteUrl,
            'pageIndex': 1,
            'limit': 5000
        };

        let jsonResponse = await LibraryApiCall.makeLibraryApiCall(
            'GetLibraryCategoryListForPublic',
            requestData,
            '/api/library/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetCategoryList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    categoryList: apiResult
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting location list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET LIBRARY BOOKS DETAILS
    apiCallToGetLibraryBooksDetails = async () => {
        if(Object.keys(this.state.bookDetails).length < 1) {
            this.setState({
                bookFetching: true,
            });

        }

        let requestData = {
            "instituteUrl": this.state.instituteUrl,
            "title": this.state.filterTitle,
            "author": this.state.filterAuthor,
            "department": this.state.filterDepartment,
            "location": this.state.filterLocation,
            "resourceType": this.state.filterResourceType,
            "accessionNo": this.state.filterAccessionNumber,
            "isbnNo": this.state.filterISBNNumber,
            'accessionSeriesId': this.state.filterAccessionSeries,
            "limit": this.state.limit,
            "pageIndex": this.state.pageIndex,
            "categoryId":this.state.filteredCategoryId,
            "edition":this.state.filterEdition,
        };

        let jsonResponse = await LibraryApiCall.makeLibraryApiCall(
            'getPublicLinkResourceData',
            requestData,
            '/api/library/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLibraryBooksDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let bookDetails = this.state.bookDetails;
                Object.assign(bookDetails, apiResult);
                this.setState({
                    bookFetching: false,
                    bookDetails,
                    total: jsonResponse.APIResult.totalCount
                });
            } else {
                this.setState({
                    bookFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting library book details. Please try again later.'
                });
            }
        }
    }

    // METHOD TO APPLY FILTER
    applyFilter = () => {
        this.setState({
            bookDetails: {},
            pageIndex: 1,
        }, () => {
            this.apiCallToGetLibraryBooksDetails();
        });
    }

    // METHOD TO CLEAR FILTER
    clearFilter = () => {
        this.setState({
            filterTitle: '',
            filterAuthor: '',
            filterDepartment: '',
            filterLocation: '',
            filterResourceType: '',
            filterAccessionNumber: '',
            filterISBNNumber: '',
            filterAccessionSeries: '',
            filteredCategoryId:'',
            filterEdition:''
        });
    }

    // METHOD TO SET BOOK DETAILS TO VIEW
    setBookDetailsToView = (book) => {
        this.setState({
            viewBook: true,
            uniqueBookId: book.uniqueId
        }, () => {
            // METHOD CALLED TO GET INDIVIDUAL BOOK DETAILS
            this.apiCallToGetIndividualBookDetails();
        });
    }

    // API CALL METHOD TO GET INDIVIDUAL BOOK DETAILS
    apiCallToGetIndividualBookDetails = async () => {
        this.setState({
            individualBookFetching: true,
        });

        let requestData = {
            "instituteUrl": this.state.instituteUrl,
            "uniqueId": this.state.uniqueBookId,
        };

        let jsonResponse = await LibraryApiCall.makeLibraryApiCall(
            'getPublicLinkIndividualResourceData',
            requestData,
            '/api/library/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetIndividualBookDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    individualBookDetails: false,
                    individualBookDetails: apiResult[this.state.uniqueBookId],
                });
            } else {
                this.setState({
                    individualBookDetails: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting individual book details. Please try again later.'
                });
            }
        }
    }

    // METHOD TO RETURN INDIVIDUAL BOOK VIEW
    returnViewBook = () => {
        let bookDetails = this.state.individualBookDetails;
        return(
            <div className={this.state.viewBook ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered viewBook-dialog">
                    <div className="modal-content viewBook-content">
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'book']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Book Details</h3>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeViewBook()}/>
                        </div>
                        <div className="modal-body viewBook-body">
                            <div className="book-details-view">
                                <div className="bookImage-copies col-md-3">
                                    <img height='100%' width='100%' src={(bookDetails.Attachment != undefined && bookDetails.Attachment != '') ? bookDetails.attachmentPath + '/' + bookDetails.Attachment[0] : bookImage} />
                                    <p className="copies-message" style={{ color: bookDetails.availableCount > 0 ? '#219653' : '#EB5757', fontWeight: 'bold', marginTop: '10%' }}>{bookDetails.availableCount > 0 ? bookDetails.availableCount + ' copy available to issue.' : 'No copies available.'}</p>
                                </div>
                                <div className="bookData col-md-9">
                                    <div className="book-title">
                                        <h4>{bookDetails.Title}</h4>
                                    </div>
                                    <div className="book-author">
                                        <p style={{ color: 'rgba(0,0,0,0.5)', fontSize: 14, marginTop: 10 }}>{bookDetails.Author}</p>
                                    </div>
                                    <div className="book-publisher">
                                        <p style={{ color: '#A40DBD', fontWeight: 'bold', marginTop: 10 }}>{bookDetails.publisher_name}</p>
                                    </div>
                                    <div className="bookDetails-container col-md-10">
                                        <div className="bookAllDetails" style={{ padding: 0 }}>
                                            {
                                                bookDetails.ISBN != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>ISBN Number</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.ISBN}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.seriesText != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Accession Series</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.seriesText}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.accessionNumber != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Accession Number</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.accessionNumber}</p>
                                                    </div>
                                            }
                                              {
                                                bookDetails.accessionDate != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%'  }}>Accession Date </p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.accessionDate}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.callNumber != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Call Number</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.callNumber}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.edition != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Edition</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.edition}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.streamName != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Department</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.streamName}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.locationName != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Location</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.locationName}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.resourceType != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Resource Type</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.resourceType}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.resourceVolume != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Resource Volume</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.resourceVolume}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.resourceLanguage != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Resource Language</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.resourceLanguage}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.numberOfPages != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Number of Pages</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.numberOfPages}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.preliminaryPages != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Number of Preliminary Pages</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.preliminaryPages}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.yearOfPublication != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Year of Publication</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.yearOfPublication}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.translator != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Translator Name</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.translator}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.searchKeyword != '' &&
                                                    <div style={{ display: 'flex' }}>
                                                        <p style={{ width: '50%' }}>Search Keyword</p>
                                                        <p style={{ width: '50%' }}>:  {bookDetails.searchKeyword}</p>
                                                    </div>
                                            }
                                        </div>
                                        <div className="bookAllDetails-mobile">
                                            {
                                                bookDetails.ISBN != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>ISBN Number</p>
                                                        <p>{bookDetails.ISBN}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.seriesText != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Accession Series</p>
                                                        <p>{bookDetails.seriesText}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.accessionNumber != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Accession Number</p>
                                                        <p>{bookDetails.accessionNumber}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.accessionDate != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Accession Date </p>
                                                        <p>{bookDetails.accessionDate}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.callNumber != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Call Number</p>
                                                        <p>{bookDetails.callNumber}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.streamName != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Department</p>
                                                        <p>{bookDetails.streamName}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.locationName != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Location</p>
                                                        <p>{bookDetails.locationName}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.resourceType != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Resource Type</p>
                                                        <p>{bookDetails.resourceType}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.resourceVolume != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Resource Volume</p>
                                                        <p>{bookDetails.resourceVolume}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.resourceLanguage != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Resource Language</p>
                                                        <p>{bookDetails.resourceLanguage}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.numberOfPages != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Number of Pages</p>
                                                        <p>{bookDetails.numberOfPages}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.preliminaryPages != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Number of Preliminary Pages</p>
                                                        <p>{bookDetails.preliminaryPages}</p>
                                                    </div>
                                            }
                                             {
                                                bookDetails.yearOfPublication != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Year of Publication</p>
                                                        <p>{bookDetails.yearOfPublication}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.translator != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Translator Name</p>
                                                        <p>{bookDetails.translator}</p>
                                                    </div>
                                            }
                                            {
                                                bookDetails.searchKeyword != '' &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <p style={{ fontWeight: 'bold' }}>Search Keyword</p>
                                                        <p>{bookDetails.searchKeyword}</p>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE VIEW BOOK
    closeViewBook = () => {
        this.setState({
            viewBook: false
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        return(
            <>
                {
                    this.state.instituteDetailsFetching ?
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20%' }}>
                            <Spinner />
                        </div>
                    :
                        this.state.invalidUrl ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <p className="invalid-url-message">Invalid URL.</p>
                            </div>
                        :
                            <div className="library-container">
                                <div className="college-name-container">
                                    <p>{ReactHtmlParser(this.state.instituteName)}</p>
                                </div>
                                <div className="library-filter-links">
                                    <p className={this.state.currentActiveFilter == 'all' ? 'all link-active' : 'all'} onClick={() => this.setState({ currentActiveFilter: 'all' })}>All</p>
                                    <p className={this.state.currentActiveFilter == 'search' ? 'search link-active' : 'search'} onClick={() => this.setState({ currentActiveFilter: 'search' })}>Search</p>
                                    <p className={this.state.currentActiveFilter == 'browse' ? 'browse link-active' : 'browse'} onClick={() => this.setState({ currentActiveFilter: 'browse' })}>Browse</p>
                                    <p className={this.state.currentActiveFilter == 'isbn' ? 'isbn link-active' : 'isbn'} onClick={() => this.setState({ currentActiveFilter: 'isbn' })}>ISBN Search</p>
                                    <p className={this.state.currentActiveFilter == 'accession' ? 'accession link-active' : 'accession'} onClick={() => this.setState({ currentActiveFilter: 'accession' })}>Accession Search</p>
                                </div>
                                <div className="dataContainer col-md-12" style={{ padding: 0 }}>
                                    <div className="filterContainer">
                                        {
                                            this.state.currentActiveFilter == 'all' ?
                                                <div className="filter-details">
                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">Title</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterTitle}
                                                            placeholder="Enter title"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterTitle: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">Author</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterAuthor}
                                                            placeholder="Enter author"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterAuthor: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">Department</label>
                                                        <select
                                                            value={this.state.filterDepartment}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterDepartment: e.target.value })}
                                                        >
                                                            <option value="">Select Department</option>
                                                            {
                                                                this.state.departmentList.length > 0 &&
                                                                    this.state.departmentList.map(department => {
                                                                        return(
                                                                            <option key={department.sid} value={department.sid}>{department.name}</option>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">Location</label>
                                                        <select
                                                            value={this.state.filterLocation}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterLocation: e.target.value })}
                                                        >
                                                            <option value="">Select Location</option>
                                                            {
                                                                Object.keys(this.state.locationList).length > 0 &&
                                                                    Object.values(this.state.locationList).map(location => {
                                                                        return(
                                                                            <>
                                                                                <option key={location.locationId} value={location.locationId}>{location.name}</option>
                                                                                {
                                                                                    Object.keys(location.sublocation).length > 0 &&
                                                                                        Object.values(location.sublocation).map(sublocation => {
                                                                                            return(
                                                                                                <option key={sublocation.locationId} value={sublocation.locationId}>{sublocation.name}</option>
                                                                                            );
                                                                                        })
                                                                                }
                                                                            </>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">Resource Type</label>
                                                        <select
                                                            value={this.state.filterResourceType}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterResourceType: e.target.value })}
                                                        >
                                                            <option value="">Select Resource Type</option>
                                                            {
                                                                this.state.resourceTypes.length > 0 &&
                                                                    this.state.resourceTypes.map(resource => {
                                                                        return(
                                                                            <option key={resource} value={resource}>{resource}</option>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">Edition</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterEdition}
                                                            placeholder="Enter Edition"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterEdition: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">Accession Number</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterAccessionNumber}
                                                            placeholder="Enter Accession Number"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterAccessionNumber: e.target.value })}
                                                        />
                                                    </div>

                                                    <div className="filterAllItem">
                                                        <label className="filterLabel">ISBN Number</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterISBNNumber}
                                                            placeholder="Enter ISBN Number"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterISBNNumber: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filter-buttons">
                                                        <button className="btn primary-button applyFilter" onClick={() => this.applyFilter()}>
                                                            Go
                                                        </button>
                                                        <p style={{ color: '#0465AC', cursor: 'pointer', fontSize: 14 }} onClick={() => this.clearFilter()}>Reset</p>
                                                    </div>
                                                </div>
                                            :
                                            this.state.currentActiveFilter == 'search' ?
                                                <div className="filter-details">
                                                    <div className="filterItem col-md-3">
                                                        <label className="filterLabel">Title</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterTitle}
                                                            placeholder="Enter title"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterTitle: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filterItem col-md-3">
                                                        <label className="filterLabel">Author</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterAuthor}
                                                            placeholder="Enter author"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterAuthor: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filter-buttons">
                                                        <button className="btn primary-button applyFilter" onClick={() => this.applyFilter()}>
                                                            Go
                                                        </button>
                                                        <p style={{ color: '#0465AC', cursor: 'pointer', fontSize: 14 }} onClick={() => this.clearFilter()}>Reset</p>
                                                    </div>
                                                </div>
                                            :
                                            this.state.currentActiveFilter == 'browse' ?
                                                <div className="filter-details">
                                                    <div className="filterItem col-md-2">
                                                        <label className="filterLabel">Category</label>
                                                        <select
                                                            value={this.state.filteredCategoryId}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filteredCategoryId: e.target.value })}
                                                        >
                                                            <option value="">Select Category</option>
                                                            {
                                                                Object.keys(this.state.categoryList).length > 0 &&
                                                                    Object.values(this.state.categoryList).map(category => {
                                                                        return(
                                                                            <>
                                                                                <option key={category.uniqueId} value={category.uniqueId}>{category.name}</option>
                                                                                
                                                                            </>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filterItem col-md-2">
                                                        <label className="filterLabel">Department</label>
                                                        <select
                                                            value={this.state.filterDepartment}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterDepartment: e.target.value })}
                                                        >
                                                            <option value="">Select Department</option>
                                                            {
                                                                this.state.departmentList.length > 0 &&
                                                                    this.state.departmentList.map(department => {
                                                                        return(
                                                                            <option key={department.sid} value={department.sid}>{department.name}</option>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filterItem col-md-2">
                                                        <label className="filterLabel">Location</label>
                                                        <select
                                                            value={this.state.filterLocation}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterLocation: e.target.value })}
                                                        >
                                                            <option value="">Select Location</option>
                                                            {
                                                                Object.keys(this.state.locationList).length > 0 &&
                                                                    Object.values(this.state.locationList).map(location => {
                                                                        return(
                                                                            <>
                                                                                <option key={location.locationId} value={location.locationId}>{location.name}</option>
                                                                                {
                                                                                    Object.keys(location.sublocation).length > 0 &&
                                                                                        Object.values(location.sublocation).map(sublocation => {
                                                                                            return(
                                                                                                <option key={sublocation.locationId} value={sublocation.locationId}>{sublocation.name}</option>
                                                                                            );
                                                                                        })
                                                                                }
                                                                            </>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filterItem col-md-2">
                                                        <label className="filterLabel">Resource Type</label>
                                                        <select
                                                            value={this.state.filterResourceType}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterResourceType: e.target.value })}
                                                        >
                                                            <option value="">Select Resource Type</option>
                                                            {
                                                                this.state.resourceTypes.length > 0 &&
                                                                    this.state.resourceTypes.map(resource => {
                                                                        return(
                                                                            <option key={resource} value={resource}>{resource}</option>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filter-buttons">
                                                        <button className="btn primary-button applyFilter" onClick={() => this.applyFilter()}>
                                                            Go
                                                        </button>
                                                        <p style={{ color: '#0465AC', cursor: 'pointer', fontSize: 14 }} onClick={() => this.clearFilter()}>Reset</p>
                                                    </div>
                                                </div>
                                            :
                                            this.state.currentActiveFilter == 'isbn' ?
                                                <div className="filter-details">
                                                    <div className="filterItem col-md-4">
                                                        <label className="filterLabel">ISBN Number</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterISBNNumber}
                                                            placeholder="Enter ISBN Number"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterISBNNumber: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filter-buttons">
                                                        <button className="btn primary-button applyFilter" onClick={() => this.applyFilter()}>
                                                            Go
                                                        </button>
                                                        <p style={{ color: '#0465AC', cursor: 'pointer', fontSize: 14 }} onClick={() => this.clearFilter()}>Reset</p>
                                                    </div>
                                                </div>
                                            :
                                            this.state.currentActiveFilter == 'accession' &&
                                                <div className="filter-details">
                                                    <div className="filterItem col-md-3">
                                                        <label className="filterLabel">Accession Series</label>
                                                        <select
                                                            value={this.state.filterAccessionSeries}
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterAccessionSeries: e.target.value })}
                                                        >
                                                            <option value="">Select Accession Series</option>
                                                            {
                                                                Object.keys(this.state.accessionSeriesList).length > 0 &&
                                                                    Object.values(this.state.accessionSeriesList).map(series => {
                                                                        return(
                                                                            <option key={series.seriesId} value={series.seriesId}>{series.seriestext}</option>
                                                                        );
                                                                    })
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="filterItem col-md-3">
                                                        <label className="filterLabel">Accession Number</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.filterAccessionNumber}
                                                            placeholder="Enter Accession Number"
                                                            className="form-control filterInput"
                                                            onChange={(e) => this.setState({ filterAccessionNumber: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="filter-buttons">
                                                        <button className="btn primary-button applyFilter" onClick={() => this.applyFilter()}>
                                                            Go
                                                        </button>
                                                        <p style={{ color: '#0465AC', cursor: 'pointer', fontSize: 14 }} onClick={() => this.clearFilter()}>Reset</p>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                    {
                                        this.state.bookFetching ?
                                            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10%' }}>
                                                <Spinner />
                                            </div>
                                        :
                                            <div className="bookList">
                                                {
                                                    Object.keys(this.state.bookDetails).length > 0 ?
                                                        Object.values(this.state.bookDetails).map(book => {
                                                            if(book.Title != undefined) {
                                                                return(
                                                                    <div className="col-md-4" key={book.uniqueId}>
                                                                        <div className="book-card" onClick={() => this.setBookDetailsToView(book)}>
                                                                            <div className="book-details">
                                                                                <div className="book-image">
                                                                                    <img src={(book.Attachment == '' || book.Attachment == undefined) ? bookImage : (book.attachmentPath + '/' + book.Attachment[0])} height='100%' width="100%" />
                                                                                </div>
                                                                                <div className="book-data">
                                                                                    <p className="book-title" title={book.Title}>{book.Title}</p>
                                                                                    <p className="book-author" title={book.Author}>{book.Author}</p>
                                                                                    <p className="book-count" style={{ color: book.availableCount > 0 ? '#219653' : '#EB5757' }}>{book.availableCount > 0 ?  book.availableCount + ' copy available to issue.' : 'No copies available.'}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        })
                                                    :
                                                        <p style={{ padding: 15 }}>No book details found for the institute.</p>
                                                }
                                            </div>
                                    }
                                </div>
                            </div>

                }
                {
                    this.returnViewBook()
                }
                {
                    this.state.successModal &&
                        <SuccessModal 
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
            </>
        );
    }
}

export default LibraryDetails;